import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import "./Menu.scss";
import useBackend, { XLogOff, IsLoggedIn } from "../services/useBackend";
import { FaStore, FaSms, FaSignOutAlt, FaKey, FaCog } from "react-icons/fa";

import { Headline } from "./ContentStyles";
import { Box } from "./FooterStyles";
import { Branding } from "../services/misc";




const MenuNar = () => {
  var { loggedIn, isSuperUser, userName, isSuperUser } = IsLoggedIn();
  var [isNavCollapsed, setIsNavCollapsed] = useState(true);

  var handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);


  return (
    <Box className="menu-wrapper">
      <nav className="navbar navbar-expand-xl navbar-dark">
        <Container>

          <div className="brand-icon-circle">
            <FaStore className="brand-icon" />
          </div>
          <a className="navbar-brand brand-with-icon" href="/">
            <Headline>{Branding().Headline}</Headline>
          </a>


          <button
            className="custom-toggler navbar-toggler"
            type="button"
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
          >
            <ul className="navbar-nav">
              {loggedIn ? (
                <>
                  {
                  (userName=='solvesborg@echealthclub.se' ||
                  userName=='olofstrom@echealthclub.se' ||
                  userName=='loddekopinge@echealthclub.se' ||
                  userName=='landskrona@echealthclub.se'
                  )
                  
                  ? (
                    <>                  
                      <a className="nav-item nav-link" href="/customers">Kunder</a>
                    </>) : (
                    <>
                      <a className="nav-item nav-link" href="/">Översikt</a>
                      <a className="nav-item nav-link" href="/products">Varor</a>
                      <a className="nav-item nav-link" href="/shops">Butiker</a>
                      {/* <a className="nav-item nav-link" href="/customers">Kunder</a> */}
                      <a className="nav-item nav-link" href="/orders">Besök</a>
                      <a className="nav-item nav-link" href="/sellreport">Försäljning</a>                    
                    </>)}
                  {isSuperUser && (
                    <>
                      {/* Visa vad som imporsonifieras */}
                      {localStorage.getItem('instanceDetailsData')}
                      {/* <a className="nav-item nav-link" href="/Project">Project</a>
                      <a className="nav-item nav-link" href="/Instances">Instanser</a> */}
                    </>
                  )}
                </>
              ) : (
                <>
                  <a className="nav-item nav-link active" href="/">Hem</a>
                  <a className="nav-item nav-link" href="/start">Starta butik</a>
                  <a className="nav-item nav-link" href="/contact">Kontakt</a>
                  <a className="nav-item nav-link" href="/faq">Frågor</a>
                </>
              )}
            </ul>

            <ul className="navbar-nav ms-auto">
              {loggedIn && (
                <div className="dropdown nav-link user-dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {userName}
                  </a>


                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="/reports">
                      <FaCog /> Rapporter
                    </a>

                    {isSuperUser && (<>
                    <a className="dropdown-item" href="/instances">
                      <FaCog /> Instances
                    </a>

                    <a className="dropdown-item" href="/globalproducts">
                      <FaCog /> Globala produkter
                    </a>                    

                    <a className="dropdown-item" href="/iotcore">
                      <FaCog /> IOTCore
                    </a>   </>)}                 

                    <a className="dropdown-item" href="/instance/invoices">
                      <FaSms /> Mina Fakturor
                    </a>
                    <a className="dropdown-item" href="/mypage">
                      <FaCog /> Min Profil
                    </a>
                    <a className="dropdown-item" href="/password/change">
                      <FaKey /> Byt lösenord
                    </a>
                    <a className="dropdown-item" onClick={XLogOff}>
                      <FaSignOutAlt /> Logga ut
                    </a>
                  </div>
                </div>
              )}



              {!loggedIn && (
                <Button
                  className="CloudLoginButton"
                  variant="primary"
                  href="/login"
                >
                  Logga in
                </Button>
              )}
            </ul>
          </div>
        </Container>
      </nav>
    </Box>
  );
};

export default MenuNar;